import { render, staticRenderFns } from "./house.vue?vue&type=template&id=02524e37&scoped=true&"
import script from "./house.vue?vue&type=script&lang=js&"
export * from "./house.vue?vue&type=script&lang=js&"
import style0 from "./house.vue?vue&type=style&index=0&id=02524e37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02524e37",
  null
  
)

export default component.exports